<script setup lang="ts">
    import type { LocaleCode } from '~/i18n/locales';
    import type { TeaserDetailsItem } from '~/types/academy/baseTraining';

    const props = defineProps<{
        item: TeaserDetailsItem;
    }>();

    // we currently need to resolve the BCP 47 locale tag manually due to a bug in the vue i18n module.
    const { i18nLocale } = useLanguage() as unknown as { i18nLocale: LocaleCode };

    const courseItem = computed(() => (props.item.type === 'course' ? props.item : null));
</script>

<template>
    <div class="teaser-details">
        <div
            v-if="courseItem?.durationMinutes"
            class="details-icon"
        >
            <TeaserIcon :icon="'hfp:clock'" />
            <span class="details-text">{{ courseItem.durationMinutes }} {{ $t('academy.duration.minutes') }}</span>
        </div>
        <div
            v-if="courseItem?.points"
            class="details-icon"
        >
            <TeaserIcon :icon="'lucide:star'" />
            <span class="details-text">{{ courseItem.points }} {{ $t('account.bonus.unit') }}</span>
        </div>
        <div
            v-if="courseItem?.hasCertificate"
            class="details-icon"
        >
            <TeaserIcon :icon="'lucide:award'" />
            <span class="details-text">{{ $t('academy.training.certificateAvailable') }}</span>
        </div>
        <div
            v-if="item.type === 'event' && item.startsAt"
            class="details-icon"
        >
            <TeaserIcon :icon="'hfp:calendar'" />
            <span class="details-text">{{ $d(item.startsAt, 'short', i18nLocale) }}</span>
        </div>
        <div
            v-if="item.type === 'event' && item.location"
            class="details-icon"
        >
            <TeaserIcon :icon="'hfp:map-pin'" />
            <span class="details-text">{{ item.location }}</span>
        </div>
    </div>
</template>

<style scoped lang="scss">
    .teaser-details {
        display: grid;
        grid-template-columns: 1fr 1fr;
        gap: $spacing--05;
    }

    .details-icon {
        display: flex;
        align-items: center;
        gap: $spacing--05;
    }

    .details-text {
        font-size: $font-s;
        line-height: 1.2;
    }
</style>
